<template>
  <div class="customizer-font">
    <div class="row row-space-4" v-if="!config.hideFontFamily || !config.hideFontSize">
      <div class="col-md-8" v-if="!config.hideFontFamily">
        <label>Family</label>
        <select class="form-control" v-model="fontFamily" @change="onFontFamilyChanged">
          <optgroup label="System Fonts">
            <option v-for="(value, key) in defaultFonts" :key="key" :value="key" v-if="!(config.noInherit && key === 'inherit')">{{value.family}}</option>
          </optgroup>
          <optgroup label="Google Fonts">
            <option v-for="(value, key) in googleFonts" :key="key" :value="key">{{value.family || key}}</option>
          </optgroup>
        </select>
      </div>
      <div class="col-md-4 customizer-trbl" v-if="!config.hideFontSize">
        <label>Size</label>
        <div class="input-group">
          <input type="number" class="form-control"
            :value="fontSize | removeUnit"
            @input="fontSize = addUnit($event.target.value, 'px')">
          <div class="input-group-append">
            <span class="input-group-text" title="Pixel">PX</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-space-4">
      <div class="col-md-6" v-if="!config.hideFontFamily">
        <label>Variant</label>
        <select class="form-control" v-model="fontVariant_">
          <option v-for="variant in fontVariants" :key="`${fontFamily}:${variant}`" :value="variant" v-if="!(config.noInherit && variant === 'inherit')">{{variant | prettyFontVariant}}</option>
        </select>
      </div>
      <div class="col-md-6" v-if="!config.hideTextTransform">
        <label>Transform</label>
        <OptionsCustomizer
          :options="[
            {
              key: 'uppercase',
              value: 'AA'
            },
            {
              key: 'capitalize',
              value: 'Aa Aa'
            },
            {
              key: 'lowercase',
              value: 'aa'
            }
          ]"
          v-model="textTransform"
          unsetTo="none" />
      </div>
      <div class="col-md-6" v-if="!config.hideTextAlign && textAlign">
        <label>Alignment</label>
        <OptionsCustomizer
          :options="[
            {
              key: 'left',
              value: 'icon-align-left'
            },
            {
              key: 'center',
              value: 'icon-align-center'
            },
            {
              key: 'right',
              value: 'icon-align-right'
            },
            {
              key: 'justify',
              value: 'icon-align-justify'
            }
          ]"
          v-model="textAlign"
          unsetTo="unset" :icon="true" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import OptionsCustomizer from '@/components/customizers/OptionsCustomizer'

import filters from '@/mixins/filters'
import mapMultiComputed from '@/mixins/mapMultiComputed'

import defaultFonts from '@/json/defaultFonts'
import googleFonts from '@/json/googleFonts'

export default {
  mixins: [
    filters,
    mapMultiComputed('amptheme', [ 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'fontVariant', 'textAlign', 'textTransform' ], true)
  ],
  components: {
    OptionsCustomizer
  },
  props: {
    category: String,
    config: Object
  },
  created: function () {
    if (!this.config.hideTextAlign) {
      if (this.textAlign === undefined) {
        this.textAlign = 'unset'
      }
    }
  },
  computed: {
    defaultFonts: function () {
      return defaultFonts
    },
    googleFonts: function () {
      return googleFonts
    },
    ...mapState([ 'amptheme' ]),
    fontVariants: function () {
      if (this.googleFonts[this.fontFamily]) return this.googleFonts[this.fontFamily].variants
      return this.defaultFonts[this.fontFamily].variants
    },
    fontVariant_: {
      get () {
        return this.fontVariant
      },
      set (value) {
        if (value.includes('italic')) {
          this.fontStyle = 'italic'
        } else {
          this.fontStyle = 'normal'
        }

        const weight = value.match(/\d+/g)

        if (weight) {
          this.fontWeight = weight[0]
        } else if (value.toLowerCase() === 'regular' || value.toLowerCase() === 'normal' || value.toLowerCase() === 'italic') {
          this.fontWeight = '400'
        } else {
          this.fontWeight = value
        }

        this.fontVariant = value
      }
    }
  },
  methods: {
    setFontVariantToRegular: function () {
      if (this.fontVariants.includes('regular')) {
        this.fontVariant = 'regular'
      } else {
        if (this.fontVariants[0] === 'inherit') {
          this.fontVariant = this.fontVariants[1]
        } else {
          this.fontVariant = this.fontVariants[0]
        }
      }
    },
    onFontFamilyChanged: function (e) {
      this.$nextTick(this.setFontVariantToRegular)
    }
  },
  filters: {
    prettyFontVariant: function (value) {
      if (value === 'inherit') return 'Same as body'

      value = filters.methods.upperFirst(value)

      const pair = value.match(/(\d[a-zA-Z])/g)

      if (pair) {
        const index = value.indexOf(pair[0])
        const prefix = value.substring(0, index + 1)
        const suffix = filters.methods.upperFirst(value.substring(index + 1))

        return [ prefix, suffix ].join(' ')
      }

      return value
    }
  }
}
</script>
